import * as React from 'react';

class ESRIMap extends React.Component<{},{},{}>{
    constructor(props, context){
        super(props, context);

    }

    componentDidMount(){
        let esri = (window as any).esri;
        esri.require([
            "dojo/dom", "dojo/on","esri/config","esri/map","esri/dijit/BasemapGallery","esri/arcgis/utils", "dojo/parser","esri/graphicsUtils", "esri/layers/ArcGISDynamicMapServiceLayer","esri/layers/ImageParameters","esri/Color","esri/geometry/Point",
            "esri/tasks/query", "esri/tasks/QueryTask", "esri/TimeExtent", "esri/graphic","esri/symbols/SimpleMarkerSymbol","esri/symbols/SimpleLineSymbol","esri/symbols/SimpleFillSymbol",
            "esri/symbols/PictureMarkerSymbol","esri/tasks/GeometryService", "esri/tasks/BufferParameters","dijit/layout/ContentPane","dijit/TitlePane","dijit/layout/BorderContainer",
            "esri/dijit/FeatureTable","esri/geometry/Polyline","esri/urlUtils","dojo/domReady!"
          ], function (dom, on, esriConfig, Map, BasemapGallery, arcgisUtils, parser, graphicsUtils, ArcGISDynamicServiceLayer, ImageParameters, Color, Point, Query, QueryTask, TimeExtent, Graphic, SimpleMarkerSymbol, SimpleLineSymbol, SimpleFillSymbol,PictureMarkerSymbol, GeometryService, BufferParameters, ContentPane,TitlePane, BorderContainer, FeatureTable, Polyline, urlUtils ) {
            parser.parse();
    
            //esriConfig.defaults.io.proxyUrl = "http://pq/arcgisproxynew/proxy.ashx";
            //esriConfig.defaults.io.alwaysUseProxy=false;
            
            urlUtils.addProxyRule({
                proxyUrl: "http://pq/arcgisproxynew/proxy.ashx",
                urlPrefix: "https://gis.tva.gov/arcgis/rest/services/"
            });
    
            var map;
            var gsvc = new GeometryService("https://gis.tva.gov/arcgis/rest/services/Utilities/Geometry/GeometryServer");
            var ltgqueryTask = new QueryTask("https://gis.tva.gov/arcgis/rest/services/EGIS/LightningQuery/MapServer/0");
            var lnqueryTask = new QueryTask("https://gis.tva.gov/arcgis/rest/services/EGIS_Transmission/Transmission_Grid_Restricted_2/MapServer/6");
    
    
            map = new esri.Map("map", { basemap: "gray", center: [-86, 35], zoom:7 });
    
             var basemapGallery = new BasemapGallery({
                showArcGISBasemaps: true,
                map: map
                }, "basemapGallery");
    
              basemapGallery.startup();
    
              basemapGallery.on("error", function(msg) {
                console.log("basemap gallery error:  ", msg);
              });
    
    
    
            var txLayer = new esri.layers.ArcGISDynamicMapServiceLayer("https://gis.tva.gov/arcgis/rest/services/EGIS_Transmission/Transmission_Grid_Restricted_2/MapServer", {"id":"txlines","opacity": 0.5, "visible":true});
            map.addLayer(txLayer);
    
    
            var imageParms=new ImageParameters();
            imageParms.layerIds=[8];
            imageParms.layerOption=ImageParameters.LAYER_OPTION_SHOW;
            var lscLayer = new esri.layers.ArcGISDynamicMapServiceLayer("https://gis.tva.gov/arcgis/rest/services/EGIS_Transmission/Transmission_Station_Assets/MapServer", {"id":"LSC","visible":true, "imageParameters":imageParms});
             map.addLayer(lscLayer);
    
    
            var lineHazardsLayer = new esri.layers.ArcGISDynamicMapServiceLayer("https://gis.tva.gov/arcgis/rest/services/EGIS_Transmission/Property_Hazards/MapServer", {"id":"lineHazards","opacity": 0.5, "visible":true});
            map.addLayer(lineHazardsLayer);
    
    
            var lineSymbol = new SimpleFillSymbol();
            lineSymbol.setColor(new Color([100,100,100,0.25]));
            lineSymbol.setOutline(null);
    
            var fltLine = new SimpleLineSymbol();
            fltLine.setWidth(3);
            fltLine.setColor(new Color([26, 26, 26, 1]));
            var faultSymbol = new SimpleMarkerSymbol();
            faultSymbol.setStyle(SimpleMarkerSymbol.STYLE_X);
            faultSymbol.setColor(new Color([255, 0, 0, 0]));
            faultSymbol.setOutline(fltLine);
    
            var ltgLine = new SimpleLineSymbol();
            ltgLine.setWidth(3);
            ltgLine.setColor(new Color([26, 26, 26, 1]));
            ltgLine.setColor(new Color([230, 230, 0, 1]));
            var ltgSymbol = new SimpleMarkerSymbol();
            ltgSymbol.setStyle(SimpleMarkerSymbol.STYLE_DIAMOND);
            ltgSymbol.setColor(new Color([230, 230, 0, 1]));
            ltgSymbol.setOutline(ltgLine);
    
              var lnQuery = new Query();
            lnQuery.returnGeometry=true;
            lnQuery.outFields=["LINENAME"];
    
            var query = new Query();
            query.returnGeometry = true;
            query.outFields = [
              "DISPLAYTIME", "LATITUDE","LONGITUDE", "AMPLITUDE"
            ];
    
            on(dom.byId("execute"), "click", execute);
            on(dom.byId("reset"), "click", reset);
    
            map.on("load",execute);
    
            function reset() {
                //reset map
                map.graphics.clear();
                var center = new Point(-86,35);
                map.centerAndZoom(center,7);
    
                dom.byId("info").innerHTML = "";
    
            }
    
    
            function execute() {
                reset();
    
                var ltgSrcID = dom.byId("ltgsource").value;
                let ltgqturl = "https://gis.tva.gov/arcgis/rest/services/EGIS/LightningQuery/MapServer/" + ltgSrcID;
                ltgqueryTask = new QueryTask(ltgqturl);
    
                lnQuery.where = "UPPER(LINENAME) like '%" + dom.byId("lno").value.toUpperCase() + "%'";
                lnqueryTask.execute(lnQuery,executeltg);
                dom.byId("info").innerHTML = "Searching...";
    
            }
    
            function getOffset(t) { //t is the date object to check, returns CDT daylight saving time is in effect.
                var retVal=" CDT";
    
                if (t.toTimeString().indexOf("ST") > 0) {
                    retVal=" CST";
                }
    
                return retVal;
    
            }
    
            function executeltg (results) {
              var startoffset = getOffset(new Date(dom.byId("starttime").value));
              var endoffset = getOffset(new Date(dom.byId("endtime").value));
    
    
              var starttime = new Date(dom.byId("starttime").value + startoffset);
              var endtime = new Date(dom.byId("endtime").value + endoffset);
    
    
              var te = new TimeExtent(starttime,endtime);
              query.timeExtent = te;
    
    
              //combine line search results into a single feature
              var totalLine=[];
    
              for (var i=0, il=results.features.length; i<il;i++)
              {
                    totalLine.push(results.features[i].geometry);
              }
    
                var params = new BufferParameters();
                  params.geometries= totalLine;
                  params.unionResults=true;
                  params.distances=[0.5];
                  params.unit = esri.tasks.GeometryService.UNIT_STATUTE_MILE;
                  gsvc.buffer(params, function(geometries)
                  {
                      let graphic = new Graphic(geometries[0],lineSymbol);
                      map.graphics.add(graphic);
                      query.geometry=geometries[0];
                      query.spatialrealationship= esri.tasks.Query.SPATIAL_REL_INTERSECTS;
                      //zoom
                      zoomLine();
                      ltgqueryTask.execute(query,showResults);
    
                  });
    
    
            }
    
    
            function zoomLine() {
                map.setExtent(graphicsUtils.graphicsExtent(map.graphics.graphics), true);
    
                //add fault location to map
                var flat=dom.byId("fault_lat").value;
                var flon=dom.byId("fault_lon").value;
    
                if (flat.length > 0)
                {
                  if (flon.length > 0){
                      var faultpoint=new Point(flon,flat);
                      let graphic = new Graphic(faultpoint,faultSymbol);
                      map.graphics.add(graphic);
                  }
                }
    
            }
    
    
            function showResults (results) {
              var resultItems = [];
              var resultCount = results.features.length;
    
              if (results.features.length > 0 )
              {
                var featureAttributes = results.features[0].attributes;
                resultItems.push("<TABLE id='resultsTable'><TR>");
                for (var attr in featureAttributes)
                {
                    resultItems.push("<TH>" + attr + "</TH>");
                }
                resultItems.push("</TR>");
    
                for (var i = 0; i < resultCount; i++) {
                    let graphic = new Graphic(results.features[i].geometry, ltgSymbol);
                    map.graphics.add(graphic);
    
                    var featureAttributes = results.features[i].attributes;
                    resultItems.push("<TR>");
                    for (var attr in featureAttributes) {
                        if(!isNaN(featureAttributes[attr])) {
                          resultItems.push("<TD>" + featureAttributes[attr].toPrecision(5) + "</TD>");
                        } else {
                          resultItems.push("<TD>" + featureAttributes[attr] + "</TD>");
                        }
                    }
                    resultItems.push("</TR>");
                }
                  resultItems.push("</TABLE>");
              } else {
                  resultItems.push("No Lightning Records Found");
              }
    
    
              if (dom.byId("info").innerHTML=="Searching...") {
                  dom.byId("info").innerHTML = resultItems.join("");
              } else {
                  dom.byId("info").innerHTML = dom.byId("info").innerHTML + resultItems.join("");
              }
            }
    
          });
    
    }


    }

